import React from "react";
import styles from "../styles/Home.module.scss";
import "../styles/Home.css";
import { Link } from "react-router-dom";

// Swiper
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Hero video
import heroBg from "../img/WhatsApp Video 2026-07-09 at 12.55.15 PM.mp4";

// Carousel images
import Butobere from "../img/Butobere - Muyumbu Road/Butobere - Muyumbu Road5.JPG";
import bulisa1 from "../img/Emergency road repairs along kabale-kisoro road/IMG_6693.jpg";
import bulisa3 from "../img/buliisa oil roads/bulisa oil roads 4.JPG";
import Butobere1 from "../img/Butobere - Muyumbu Road/Butobere - Muyumbu Road8.JPG";
import kabale1 from "../img/fwdemergencyrepairskabalekisororoad/IMG_20240817_174845.jpg";
import kabale from "../img/fwdemergencyrepairskabalekisororoad/IMG_20240817_174230.jpg";
import kanungu from "../img/fwdemergencyrepairskabalekisororoad/IMG_20240817_174041.jpg";
import kanungu1 from "../img/Rukungiri -Birara-Kanungu Road works/Birara-Kanungu Road work9.JPG";
import buwama from "../img/Buwama-Kagongi-Migani Road/Buwama-Kagongi-Migani Road2.JPG";
import buwama1 from "../img/Buwama-Kagongi-Migani Road/Buwama-Kagongi-Migani Road1.JPG";
import migani from "../img/Buwama-Kagongi-Migani Road Nakaseke District/Migani Road Nakaseke.JPG";
import migani1 from "../img/Buwama-Kagongi-Migani Road Nakaseke District/Buwama-Kagongi-Migani Road Nakaseke District4.JPG";
import rukiga from "../img/Low cost sealing project works in Rukiga District/Rukiga District2.JPG";
import muyumbu from "../img/Butobere -Muyumbu road in UNRA kabale station/Butobere -Muyumbu road in UNRA kabale station3.JPG";
import rukiga2 from "../img/Low cost sealing project works in Rukiga District/Rukiga District5.jpg";
import kabale4 from "../img/Emergency road repairs along kabale-kisoro road/IMG_6688.jpg";
import kabale5 from "../img/fwdemergencyrepairskabalekisororoad/IMG_20240817_174103.jpg";
import kabale6 from "../img/fwdemergencyrepairskabalekisororoad/IMG_20240817_153743.jpg";
import machine1 from "../img/machines2/IMG-20250107-WA0011.jpg";
import zonal from "../img/soroti-project/3c39eca3-0338-4c50-9b56-9f63141671cc.jpg";
import zonal1 from "../img/soroti-project/a8d164ff-c706-45eb-b4d3-e24e8397e97b.jpg";
import zonal2 from "../img/soroti-project/179a135b-61c8-43ec-b4b3-8c950db612e5.jpg";
import kumi from "../img/kumi/kumi2.jpg";
import kumi1 from "../img/kumi/kumi.jpg";
import kumi2 from "../img/kumi/IMG_8328.jpg";
import dam from "../img/Kajamaka earth dam.jpg";

const slides = [
  { img: dam, caption: "Kajamaka Earth Dam, Kumi District" },
  { img: machine1, caption: "Kajamaka Earth Dam, Kumi District" },
  { img: zonal, caption: "Construction of Zonal Animal Disease Control Centres" },
  { img: zonal1, caption: "Zonal Animal Disease Control Centres, Soroti" },
  { img: zonal2, caption: "Zonal Animal Disease Control Centres, Soroti" },
  { img: kumi, caption: "Community Access Roads, Ongino Sub-County, Kumi" },
  { img: kumi1, caption: "Community Access Roads, Ongino Sub-County, Kumi" },
  { img: kumi2, caption: "Community Access Roads, Ongino Sub-County, Kumi" },
  { img: kabale4, caption: "Emergency Road Repairs, Kabale–Kisoro Road" },
  { img: kabale5, caption: "Emergency Repairs, Kabale–Kisoro Road" },
  { img: kabale6, caption: "Emergency Repairs, Kabale–Kisoro Road" },
  { img: bulisa1, caption: "Emergency Road Repairs, Kabale–Kisoro Road" },
  { img: rukiga2, caption: "Low Cost Sealing Project, Rukiga District" },
  { img: kanungu, caption: "Emergency Repairs, Kabale–Kisoro Road" },
  { img: bulisa3, caption: "Road Construction, Buliisa" },
  { img: muyumbu, caption: "Butobere–Muyumbu Road" },
  { img: Butobere, caption: "Butobere–Muyumbu Road" },
  { img: Butobere1, caption: "Butobere–Muyumbu Road" },
  { img: kabale, caption: "Emergency Repairs, Kabale–Kisoro Road" },
  { img: kabale1, caption: "Emergency Repairs, Kabale–Kisoro Road" },
  { img: kanungu1, caption: "Road Construction, Kanungu" },
  { img: buwama, caption: "Road Construction, Buwama" },
  { img: buwama1, caption: "Road Construction, Buwama" },
  { img: migani, caption: "Road Construction, Buwama" },
  { img: migani1, caption: "Road Construction, Migani" },
  { img: rukiga, caption: "Road Construction, Rukiga" },
];

const stats = [
  { value: "15+", label: "Years of Experience" },
  { value: "50+", label: "Projects Completed" },
  { value: "10+", label: "Districts Served" },
  { value: "100%", label: "Ugandan Owned" },
];

const services = [
  {
    icon: "🏗️",
    title: "Construction",
    desc: "Roads, dams, buildings and civil works delivered to the highest standards across Uganda.",
  },
  {
    icon: "📐",
    title: "Engineering & Supervision",
    desc: "Expert project management, engineering design and construction supervision services.",
  },
  {
    icon: "🔧",
    title: "Logistics & Staffing",
    desc: "End-to-end logistics support and professional staffing for oil, gas and infrastructure sectors.",
  },
];

const Home = () => {
  return (
    <div className={styles.container}>

      {/* ── HERO ── */}
      <section className="home-hero">
        {/* Video background */}
        <video
          className="home-hero__video"
          src={heroBg}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="home-hero__overlay" />
        <div className="home-hero__content">
          <p className="home-hero__sub">Building Uganda's Future</p>
          <h1 className="home-hero__title">Greystone Investments (U) Limited</h1>
          <p className="home-hero__tagline">
            A proudly Ugandan construction company delivering excellence in roads,
            civil works and infrastructure since 2009.
          </p>
          <div className="home-hero__actions">
            <Link to="/projects" className="home-btn home-btn--primary">
              View Our Projects
            </Link>
            <Link to="/contact" className="home-btn home-btn--outline">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="home-stats">
        {stats.map((s) => (
          <div className="home-stats__item" key={s.label}>
            <span className="home-stats__value">{s.value}</span>
            <span className="home-stats__label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ── WHAT WE DO ── */}
      <section className="home-services">
        <div className="home-section-header">
          <h2>What We Do</h2>
          <p>
            From road construction to professional staffing, we bring expertise
            and commitment to every project.
          </p>
        </div>
        <div className="home-services__grid">
          {services.map((s) => (
            <div className="home-services__card" key={s.title}>
              <span className="home-services__icon">{s.icon}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── PROJECT GALLERY ── */}
      <section className="home-gallery">
        <div className="home-section-header">
          <h2>Our Work on the Ground</h2>
          <p>A snapshot of projects delivered across Uganda.</p>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          breakpoints={{
            768: { slidesPerView: 3, spaceBetween: 20 },
            480: { slidesPerView: 1, spaceBetween: 10 },
          }}
          updateOnWindowResize={true}
          className={styles.myswiper}
        >
          {slides.map((slide, i) => (
            <SwiperSlide className={styles.swiperslide} key={i}>
              <div>
                <img src={slide.img} alt={slide.caption} />
                <span>{slide.caption}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* ── CTA STRIP ── */}
      <section className="home-cta">
        <h2>Ready to work with us?</h2>
        <p>
          Let's discuss your next construction or infrastructure project.
        </p>
        <Link to="/contact" className="home-btn home-btn--white">
          Get in Touch
        </Link>
      </section>

    </div>
  );
};

export default Home;
